export default __webpack_public_path__ + "static/media/level-courier.28c20e1d.png";